import { useQuery } from "@tanstack/react-query";
import BrieConversationAPI from "../../../api/api/BrieConversationAPI";
import { BrieGPTMessagePayload } from "./PageViewBrieGPT";
import { useAtomValue } from "jotai";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";

type ViewProps = {
  type: "view";
  viewID: string;
  chatID: string | null;
  processing: boolean;
};

type RecordProps = {
  type: "record";
  recordID: string | undefined;
  chatID: string | null;
  processing: boolean;
};

export type GetGPTMessagesProps = ViewProps | RecordProps;

const empty: [] = [];

function useChatMessages(props: GetGPTMessagesProps) {
  const tenantID = useAtomValue(tenantIDAtom);

  let queryIds: string[];

  if (props.type === "view") {
    queryIds = [props.viewID];
  } else {
    queryIds = [props.recordID || ""];
  }

  const data = useQuery({
    queryKey: [tenantID, ...queryIds, props.chatID, "BrieGPTMessages"],
    queryFn: () =>
      BrieConversationAPI.getBrieGPTChatMessages(props).then((res) => {
        const messages = res?.data?.data?.messages;

        return messages;
      }),
    enabled:
      props.type === "view"
        ? !!props.viewID && !!props.chatID
        : !!props.recordID && !!props.chatID,
    structuralSharing: false,
  });

  return {
    messages: (data.data || empty) as BrieGPTMessagePayload[],
    messagesLoading: data.isLoading && props.chatID,
  };
}

export default useChatMessages;
